import React, {useMemo, useContext} from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import context from "components/Shared/MSidebar/utility/context";

const DrawerToggle = () => {
  const {
    open,
    toggleSidebar: onClick
  } = useContext(context);
  const ToggleIcon = useMemo(
    () => open ? ChevronLeftRoundedIcon : ChevronRightRoundedIcon,
    [open]
  );
  return (
  <div className="DrawerToggle-Root">
      <IconButton
        {...{onClick}}
        size={"small"}
        className="DrawerToggle-IconButton"
      >
        <ToggleIcon/>
      </IconButton>
  </div>
  );
};

DrawerToggle.defaultProps = {
  open: true,
};

DrawerToggle.propTypes = {
  open: PropTypes.bool,
};

export default DrawerToggle;